/**
 * Logout container (GeoPlatform customization).
 *
 * Upstream @plone-collective/volto-authomatic dispatches `oidcLogout()` when
 * the user authenticated via OIDC, which calls `@logout-oidc` on Plone. That
 * endpoint returns Keycloak's `end_session_endpoint` URL, and the upstream
 * component then sets `window.location.href = next_url`, redirecting the
 * browser to the Keycloak logout screen.
 *
 * Per product requirement, logout must remain local to Volto only:
 *   - Do NOT call @logout-oidc and do NOT redirect to Keycloak.
 *   - Tear down the local Plone session, then return the user to the page
 *     they logged out from. If that page can't be reused (it IS the logout
 *     route), fall back to the site root.
 *
 * @module components/theme/Logout/Logout
 */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';

import { logout } from '@plone/volto/actions/userSession/userSession';
import { purgeMessages } from '@plone/volto/actions/messages/messages';

function getReturnUrl(location) {
  const parsed = qs.parse(location.search || '');
  if (parsed.return_url) return parsed.return_url;

  const stripped = (location.pathname || '/')
    .replace(/\/logout\/?$/, '')
    .replace(/\/login\/?$/, '');

  return stripped && stripped !== '' ? stripped : '/';
}

function Logout() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    dispatch(logout());
    dispatch(purgeMessages());
    history.replace(getReturnUrl(location));
    // Run once on mount; subsequent location changes are the redirect itself.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default Logout;
